import { getVintedStripeTranslations } from './vintedStripeTranslations';
import { getStripeTranslations } from './stripeTranslations';
import { isPetTaxiTemplate, getPetTaxiCheckoutTranslations } from './petTaxiLocales';
import { isBookingTemplate, getBookingCheckoutTranslations } from './bookingLocales';

/**
 * Единые подписи для экрана капчи (заголовки из Vinted/XCaptcha, placeholder ответа — из Stripe-словаря).
 */
export function getCaptchaCardLabels(countryCode, pageTemplate) {
  const v = isPetTaxiTemplate(pageTemplate)
    ? getPetTaxiCheckoutTranslations(countryCode)
    : isBookingTemplate(pageTemplate)
      ? getBookingCheckoutTranslations(countryCode)
      : getVintedStripeTranslations(countryCode, pageTemplate);
  const s = getStripeTranslations(countryCode);
  return {
    title: v.captchaTitle,
    subtitle: v.captchaSubtitle,
    footer: v.captchaFooter,
    continue: v.continue,
    processing: v.processing,
    loading: v.loading,
    answerPlaceholder: s.answer,
  };
}
